import React, { useEffect } from 'react';
import Header from "./header/Header";
import { GetOffer } from "../../../action/getOffer";
import { CopyTextToClipboard } from "../../../action/copyTextToClipboard";
import OfferUrlFactory from "../../../infrastructure/url-factory/OfferUrlFactory";
import { GetOfferMediums } from "../../../action/getOfferMediums";
import { Stack } from "@mui/material";
import PhotoUrlFactory from "../../../infrastructure/url-factory/PhotoUrlFactory";
import { UpdateOffer } from "../../../action/updateOffer";
import getOfferId from "../../../core/getOfferId";
import useTrackPromise from "../../hooks/useTrackPromise";
import ContentLoader from "../../components/ContentLoader";
import MediumsList, { MediumsListProps } from "./offer-creator/mediums-list/MediumsList";

const OfferPanelPage: React.FC<OfferPanelPageProps> = props => {
    const [getOffer, offer, statusGetOffer] = useTrackPromise(props.getOffer);

    useEffect(() => {
        getOffer(getOfferId());
    }, []);

    if (statusGetOffer.pending()) {
        return <ContentLoader/>;
    }

    if (!offer) {
        return 'Nie znaleziono oferty';
    }

    // const offer = createOfferStub();
    return (
        <Stack spacing={ 2 }>
            <Header
                offer={ offer }
                offerUrlFactory={ props.offerUrlFactory }
                copyTextToClipboard={ props.copyTextToClipboard }
                photoUrlFactory={ props.photoUrlFactory }
                updateOffer={ props.updateOffer }
            />
            <MediumsList { ...props.mediumsListProps }/>
        </Stack>
    );
}
export default OfferPanelPage;

export interface OfferPanelPageProps {
    readonly getOffer: GetOffer;
    readonly mediumsListProps: MediumsListProps;
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly offerUrlFactory: OfferUrlFactory;
    readonly getOfferMediums: GetOfferMediums<true>;
    readonly photoUrlFactory: PhotoUrlFactory;
    readonly updateOffer: UpdateOffer;
}